<template>
<div class="mt-3">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-3 cursor-pointer px-3 transition-opacity duration-200" :class="{ 'opacity-60': !selected }" @click="open = !open">
        <h2 class="text-white text-lg">
            {{ annee.year }}
            <span v-if="annee.is_current" class="text-xs font-normal">(en cours)</span>
        </h2>
        <span class="text-sm text-white flex items-center gap-3">
            <span :class="annee.net_total >= 0 ? 'text-green-200' : 'text-red-200'">{{ format(annee.net_total) }}</span>
            <span
                role="switch"
                :aria-checked="selected"
                tabindex="0"
                title="Inclure dans le total cumulé"
                class="relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full border-2 border-transparent cursor-pointer transition-colors duration-200 focus:outline-none"
                :class="selected ? 'bg-white' : 'bg-white/25'"
                @click.stop="$emit('toggle-selected')"
                @keydown.space.prevent.stop="$emit('toggle-selected')"
                @keydown.enter.prevent.stop="$emit('toggle-selected')"
            >
                <span
                    aria-hidden="true"
                    class="inline-block h-4 w-4 transform rounded-full shadow-sm transition duration-200"
                    :class="selected ? 'translate-x-4 bg-indigo-600' : 'translate-x-0 bg-white'"
                ></span>
            </span>
            <font-awesome-icon v-if="open" :icon="['fa', 'chevron-down']" />
            <font-awesome-icon v-else :icon="['fa', 'chevron-right']" />
        </span>
    </div>

    <div class="grid grid-cols-2 gap-2 px-2 py-3" v-if="open">
        <div class="bg-gray-100 dark:bg-gray-800 rounded p-2" v-if="annee.loyers_total !== 0">
            <div class="text-xs text-gray-500 dark:text-gray-400">Loyers</div>
            <div class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ format(annee.loyers_total) }}</div>
            <div class="text-xs text-gray-400">{{ format(annee.loyers_moyenne) }}/mois</div>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 rounded p-2" v-if="annee.charges_total !== 0">
            <div class="text-xs text-gray-500 dark:text-gray-400">Charges</div>
            <div class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ format(annee.charges_total) }}</div>
            <div class="text-xs text-gray-400">{{ format(annee.charges_moyenne) }}/mois</div>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 rounded p-2" v-if="annee.taxe_fonciere_total !== 0">
            <div class="text-xs text-gray-500 dark:text-gray-400">Taxe foncière</div>
            <div class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ format(annee.taxe_fonciere_total) }}</div>
            <div class="text-xs text-gray-400">{{ format(annee.taxe_fonciere_moyenne) }}/mois</div>
        </div>
        <div class="bg-gray-100 dark:bg-gray-800 rounded p-2" v-if="annee.prets_total !== 0">
            <div class="text-xs text-gray-500 dark:text-gray-400">Prêts</div>
            <div class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ format(annee.prets_total) }}</div>
            <div class="text-xs text-gray-400">{{ format(annee.prets_moyenne) }}/mois</div>
        </div>

        <div class="col-span-2 border-t border-gray-200 dark:border-gray-700 pt-2 flex justify-between items-center">
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Net</span>
            <div class="text-right">
                <div class="text-sm font-medium" :class="annee.net_total >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ format(annee.net_total) }}</div>
                <div class="text-xs text-gray-400">{{ format(annee.net_moyenne) }}/mois</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        annee: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            default: true
        }
    },

    emits: ['toggle-selected'],

    data() {
        return {
            open: this.annee.is_current
        }
    },

    methods: {
        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
